import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export const RESULT_PAGE_FILTER_RESET = 'RESULT_PAGE_FILTER_RESET';
export const RESULT_PAGE_FILTER_RESET_VERSION = '1.0';

export enum RESULT_PAGE_FILTER_RESET_POSITION {
  POPUP = 'POPUP',
  NO_RESULTS = 'NO_RESULTS',
  ACTIVE_FILTERS = 'ACTIVE_FILTERS',
}

export type ResultPageFilterResetParams = {
  searchParams: SearchParams;
  position: RESULT_PAGE_FILTER_RESET_POSITION;
};

export type ResultPageFilterResetPayload = {
  searchId: string;
  position: string;
};

export const createResultPageFilterResetPayload = ({
  searchParams,
  position,
}: ResultPageFilterResetParams): ResultPageFilterResetPayload => {
  const searchId = searchParams[URLParameters.SEARCH_ID];
  if (!searchId) throw new Error('searchId not present in searchParams');

  return {
    searchId,
    position,
  };
};
